import script from "./LandingES.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingES.vue?vue&type=script&setup=true&lang=js"

import "./LandingES.vue?vue&type=style&index=0&id=f118a3e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f118a3e0"]])

export default __exports__